<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CQhGQV/tc-custom/9783968657455.jpg?1740425335726" alt="This image is the cover for the book Amazing Tales Volume 24, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Tales Volume 24, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Embark on an unparalleled cosmic journey with "Amazing Tales Volume 24", a dazzling anthology that seamlessly intertwines cosmic horror, interplanetary escapades, and the timeless struggle of survival against alien adversaries. From mind-bending suspense to heart-pounding action, each story promises to transport you to new frontiers. Brace yourself for the spine-tingling intensity of "Terror Out of Space", where a pilot must battle sinister mind control on a perilous Venus. Then step into the high-octane adventure of "The Dragon-Queen of Jupiter", where a rugged hero and his Martian comrade bravely confront a winged terror on a mist-enshrouded planet. "Child of the Sun" elevates the stakes with a cosmic chase across hidden realms, ingeniously blending political intrigue with a daring fight for liberation. Delve into the mesmerizing world of "The Blue Behemoth", a pulse-pounding tale entwined with a space-faring circus draped in the mysteries of Venusian swamps. Finally, lose yourself in "Thralls of the Endless Night", a poignant exploration of betrayal and love amidst the vast, merciless void of space. Each story offers a distinctive lens through which you'll witness alien encounters, explore dystopian societies, and engage in epic interstellar conflicts. Whether your passion lies in space thrillers, cosmic conundrums, or grand space opera, "Amazing Tales Volume 24" guarantees a breathtaking voyage through the stars. Allow your imagination to soar as you lose yourself in these imaginative landscapes filled with emotional depth and suspenseful excitement. Prepare for an immersive reading experience that promises to captivate and inspire, one stellar tale at a time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leigh Brackett et al.
      </h2>
      
      <p class="authorDescription body article">Leigh Douglass Brackett (December 7, 1915  March 18, 1978) was an American writer, particularly of science fiction, and has been referred to as the Queen of Space Opera. She was also a screenwriter, known for her work on such films as "The Big Sleep  (1946), ""Rio Bravo"" (1959) and ""The Long Goodbye"" (1973). She also worked on an early draft of ""The Empire Strikes Back"" (1980), elements of which remained in the film; she died before the film went into production. She was the first woman shortlisted for the Hugo Award. In 2020, she won a Retro Hugo for her novel ""The Nemesis From Terra"", originally published as ""Shadow Over Mars"" (""Startling Stories"", Fall 1944)".</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?358023ee